import { useStateMachine } from 'little-state-machine';

import { useEffect, useState } from 'react';

import { useForm } from 'react-hook-form';

import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { FormGroup } from '../../../../../Components/FormGroup/FormGroup';
import { fetchWrapper } from '../../../../../_helpers/fetchWrapper';
import {
  convertToNumber,
  debounce,
  isNumeric,
  onlyNotSpecialCharacters,
  verifyEmail
} from '../../../../../_helpers/_methods';
import { useSelector } from 'react-redux';

import PhysicalLocationDetails from '../../../../admin/Events/Steps/components/PhysicalLocationDetails';
import updateAction from './updateAction';
import { FormattedMessage, useIntl } from 'react-intl';
import { FaInfoCircle } from 'react-icons/fa';
import NavigationButtonGroup from '../../../../admin/Events/Steps/components/NavigationButtonGroup';

function OrganizationStep0() {
  const lang = useSelector((state) => state?.local?.local);
  const rosterData = useSelector((state) => state.rosters.rosters);
  const { actions } = useStateMachine({ updateAction });
  const { state } = useStateMachine({ updateAction });
  const navigate = useNavigate();
  const { id, edit: isEdit } = useParams();
  const location = useLocation();

  const [isEmailValid, setIsEmailValid] = useState(false);
  const [isPhoneInValid, setIsPhoneInValid] = useState(false);
  const intl = useIntl();
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    // setError,
    formState: { errors }
  } = useForm({
    mode: 'onBlur',
    defaultValues: {}
  });
  useEffect(() => {
    if (isEdit && rosterData) {
      setValue('fullname', rosterData.user?.fullname);
      setValue('roster_organization_phone_num', rosterData.user?.phone);
      setValue('email', rosterData.user?.email);
      setValue('roster_organization_experience', rosterData.user?.organization[0].work_experience);
      setValue('roster_organization_pan_number', rosterData.pan);
    }
  }, [rosterData]);

  const onSubmit = async (data) => {
    if (!(await validatePhone({ phone: data.roster_organization_phone_num }))) {
      return;
    }
    if (!(await validateEmail({ email: data.email }))) {
      return;
    }
    actions.updateAction(data);
    let path = location.pathname.split('/');

    if (isEdit) {
      navigate(`/admin/rosters/organization/${id}/edit/1`);
    } else {
      path.includes('admin')
        ? navigate('/admin/rosters/organization_apply/1')
        : navigate('/rosters/organization_apply/1');
    }
  };
  const handlePhoneCheck = async (e) => {
    let body = { phone: e.target.value };
    clearErrors('roster_organization_phone_num');
    body.phone.length === 0 ? setIsPhoneInValid(false) : await validatePhone(body);
  };

  const validatePhone = async (body) => {
    try {
      if (isEdit) {
        if (rosterData.user.phone !== body.phone) {
          await fetchWrapper.post('/validate-phone/', body);
          clearErrors('roster_organization_phone_num');
          setIsPhoneInValid(false);
        }
        return true;
      } else {
        await fetchWrapper.post('/validate-phone/', body);
        setIsPhoneInValid(false);
        return true;
      }
    } catch (error) {
      setIsPhoneInValid(
        error.error[0]
          ? error.error[0]
          : lang === 'ne'
          ? error.error.non_field_error_np
          : error.error.non_field_error
      );
      return false;
    }
  };

  const handleEmailCheck = async (e) => {
    clearErrors('email');
    setIsEmailValid(false);

    let body = { email: e.target.value };
    if (body.email.length < 2) {
      setIsEmailValid(false);
    } else {
      if (verifyEmail(body.email)) {
        await validateEmail(body);
      } else {
        setIsEmailValid(intl.formatMessage({ id: 'email_validate_message' }));
      }
    }
  };

  const validateEmail = async (body) => {
    try {
      if (isEdit) {
        if (rosterData.user?.email !== body.email) {
          await fetchWrapper.post('/validate-email/', body);
          clearErrors('email');
          setIsEmailValid(true);
        }
        return true;
      } else {
        await fetchWrapper.post('/validate-email/', body);
        clearErrors('email');
        setIsEmailValid(true);
        return true;
      }
    } catch (error) {
      setIsEmailValid(
        lang === 'ne' ? error.error?.non_field_error_np : error.error?.non_field_error
      );
      return false;
    }
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="row  ">
        <div className="col-md-12">
          <div className=" alert alert-info d-flex align-items-center">
            <FaInfoCircle size={50} className="me-2" />
            <FormattedMessage id="registration.rosterWelcome" />
          </div>
        </div>
        <div className="">
          <h4 className="">
            <FormattedMessage id="organization_details" />
          </h4>
        </div>
        <div className="row px-4">
          <div className="col-md-3 mb-3">
            <FormattedMessage id="organization_full_name_placeholder">
              {(placeholder) => (
                <FormGroup
                  type="text"
                  errorId={`organization_full_name`}
                  required={true}
                  placeholder={placeholder[0]}
                  onChange={(e) => {
                    e.target.value = onlyNotSpecialCharacters(e.target.value);
                  }}
                  register={register}
                  error={errors}
                  id="fullname"
                  defaultValue={state?.fullname}
                  label={<FormattedMessage id="organization_full_name" />}
                />
              )}
            </FormattedMessage>
          </div>
          <div className="col-md-2">
            <FormattedMessage id="organization_phone_placeholder">
              {(placeholder) => (
                <FormGroup
                  type="text"
                  errorId={`organization_phone`}
                  required={true}
                  min={0}
                  max={10}
                  placeholder={placeholder[0]}
                  register={register}
                  onChange={(e) => {
                    if (isNumeric(e.target.value)) {
                      if (e.target.value.length === 0 || 1 > e.target.value.length < 10)
                        debounce(handlePhoneCheck, 1000)(e);
                    } else {
                      e.target.value = convertToNumber(e.target.value);
                      if (e.target.value.length === 0 || 1 > e.target.value.length < 10)
                        debounce(handlePhoneCheck, 1000)(e);
                    }
                  }}
                  error={errors}
                  id="roster_organization_phone_num"
                  defaultValue={state?.roster_organization_phone_num}
                  label={<FormattedMessage id="organization_phone" />}
                />
              )}
            </FormattedMessage>
            {errors.roster_organization_phone_num ? null : isPhoneInValid ? (
              <div className="ms-2">
                <small className="text-danger">{isPhoneInValid}</small>
              </div>
            ) : null}
          </div>
          <div className="col-md-3 ">
            <FormattedMessage id="organization_email_placeholder">
              {(placeholder) => (
                <FormGroup
                  type="email"
                  errorId={`organization_email`}
                  required={true}
                  placeholder={placeholder[0]}
                  register={register}
                  error={errors}
                  onChange={(e) => {
                    if (e.target.value.length === 0) {
                      setIsEmailValid(false);
                    } else {
                      debounce(handleEmailCheck, 1000)(e);
                    }
                  }}
                  id="email"
                  defaultValue={state?.email}
                  label={<FormattedMessage id="organization_email" />}
                />
              )}
            </FormattedMessage>
            {isEmailValid ? <small className="text-danger">{isEmailValid}</small> : null}
          </div>
          <div className="col-md-2">
            <FormattedMessage id="experience_in_year_placeholder">
              {(placeholder) => (
                <FormGroup
                  type="number"
                  errorId={`roster_experience_in_year`}
                  required={true}
                  min={0}
                  placeholder={placeholder[0]}
                  register={register}
                  error={errors}
                  id="roster_organization_experience"
                  defaultValue={state?.roster_organization_experience}
                  label={<FormattedMessage id="experience_in_year" />}
                />
              )}
            </FormattedMessage>
          </div>

          <div className="col-md-2">
            <FormattedMessage id="pan_number_placeholder">
              {(placeholder) => (
                <FormGroup
                  type="number"
                  errorId={`pan_number`}
                  required={true}
                  min={0}
                  placeholder={placeholder[0]}
                  register={register}
                  error={errors}
                  id="roster_organization_pan_number"
                  defaultValue={state?.roster_organization_pan_number}
                  label={<FormattedMessage id="pan_number" />}
                />
              )}
            </FormattedMessage>
          </div>
        </div>
        <div className="row">
          <h4 className="col-12">
            <FormattedMessage id="organization_address" />
          </h4>
          <div className="col-md-12 ps-4">
            <PhysicalLocationDetails
              isEdit={isEdit}
              id="rosters_organization"
              register={register}
              errors={errors}
              clearErrors={clearErrors}
              setValue={setValue}
            />
          </div>
        </div>
      </div>
      <div className="">
        <hr />
        <NavigationButtonGroup
          hasPrevious={false}
          backTo="/admin/rosters/organization_list"
          // showSubmit={id}
        />
      </div>
    </form>
  );
}

export default OrganizationStep0;
